import { Component, OnDestroy, OnInit } from '@angular/core';
import { NbMediaBreakpointsService, NbMenuService, NbSidebarService, NbThemeService } from '@nebular/theme';

import { UserData } from '../../../@core/data/users';
import { LayoutService } from '../../../@core/utils';
import { map, takeUntil } from 'rxjs/operators';
import { Subject, Observable } from 'rxjs';
import { RippleService } from '../../../@core/utils/ripple.service';
import { AuthService } from '../../../services/auth.service';
import { CookieService } from 'ngx-cookie';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit, OnDestroy {

  showErrorMessage = false;
  errorMessage = '';
  private destroy$: Subject<void> = new Subject<void>();
  public readonly materialTheme$: Observable<boolean>;
  userPictureOnly: boolean = false;
  user: any;

  themes = [
    {
      value: 'default',
      name: 'Light',
    },
    {
      value: 'dark',
      name: 'Dark',
    },
    {
      value: 'cosmic',
      name: 'Cosmic',
    },
    {
      value: 'corporate',
      name: 'Corporate',
    },
    {
      value: 'material-light',
      name: 'Material Light',
    },
    {
      value: 'material-dark',
      name: 'Material Dark',
    },
  ];

  // currentTheme = 'default';
  currentTheme = 'poste-italiane';

  userMenu = [
    {
      title: 'Profilo',
      link: '/pages/profile',
    },
    {
      title: 'Esci',
      link: undefined,
      click: () => {
        this.logout();
      },
    },
  ];

  email = '';
  logged = false;

  public constructor(
    public router: Router,
    public cookieService: CookieService,
    public auth: AuthService,
    private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private themeService: NbThemeService,
    private userService: UserData,
    private layoutService: LayoutService,
    private breakpointService: NbMediaBreakpointsService,
    private rippleService: RippleService,
  ) {
    this.materialTheme$ = this.themeService.onThemeChange()
      .pipe(map(theme => {
        const themeName: string = theme?.name || '';
        return themeName.startsWith('material');
      }))
    ;
  }

  ngOnInit() {

    this.email = this.cookieService.get('email');
    if (this.email === '' || this.email === undefined || !this.email) {
      this.logged = false;
    } else {
      this.logged = true;
    }

    this.menuService.onItemClick().subscribe((data) => {
      if (data.item.link === undefined) {
        const item = data.item as any;
        item.click();
      }
    });

    this.currentTheme = this.themeService.currentTheme;

    this.userService.loadSingleUser()
      .subscribe((users: any) => this.user = users.loggedUser);


    const { xl } = this.breakpointService.getBreakpointsMap();
    this.themeService.onMediaQueryChange()
      .pipe(
        map(([, currentBreakpoint]) => currentBreakpoint.width < xl),
        takeUntil(this.destroy$),
      )
      .subscribe((isLessThanXl: boolean) => this.userPictureOnly = isLessThanXl);

    this.themeService.onThemeChange()
      .pipe(
        map(({ name }) => name),
        takeUntil(this.destroy$),
      )
      .subscribe(themeName => {
        this.currentTheme = themeName;
        this.rippleService.toggle(themeName?.startsWith('material'));
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  changeTheme(themeName: string) {
    this.themeService.changeTheme(themeName);
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  private logout() {
    this.auth.logout()
      .then(
        (data) => {
          if (data['message'] === 'success') {
            this.cookieService.put('token', '');
            this.cookieService.put('email', '');
            this.cookieService.put('id', '');
            this.cookieService.put('permission', '');
            window.location.reload();
          } else {
            this.showErrorMessage = true;
            this.errorMessage = 'Logout fallito';
          }
        },
        (error) => {
          console.error('Errore', error);
          this.showErrorMessage = true;
          this.errorMessage = 'Errore API logout';
        },
      );
  }
}
